<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <el-breadcrumb separator="/" class="page-breadcrumb">
        <el-breadcrumb-item>
          <div class="breadcrumb">
            <div class="left"></div>
            <div class="right"><h2>返佣审核</h2></div>
          </div>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <div class="page-actions">
        <div class="select">
          <!-- <div class="item">
            <div class="txt">合伙人UID</div>
            <div class="ipt">
              <el-input placeholder="合伙人UID" clearable v-model="userId">
              </el-input>
            </div>
          </div> -->
          <!-- <div class="item">
            <div class="txt">邀请人UID</div>
            <div class="ipt">
              <el-input placeholder="邀请人UID" clearable v-model="inviteBy">
              </el-input>
            </div>
          </div>-->
          <div class="item">
            <!-- <div class="txt">合伙人UID</div> -->
            <div class="ipt">
              <el-input
                placeholder="合伙人UID"
                clearable
                v-model="channelUserId"
                size="mini"
              >
              </el-input>
            </div>
          </div>
          <div class="item">
            <!-- <div class="txt">备注</div> -->
            <div class="ipt">
              <el-input
                placeholder="备注"
                size="mini"
                clearable
                v-model="remark"
              >
              </el-input>
            </div>
          </div>
          <div class="item">
            <!-- <div class="txt">返佣日期：</div> -->
            <div class="ipt">
              <el-date-picker
                size="mini"
                v-model="value1"
                type="daterange"
                align="right"
                format="yyyy - MM - dd 日"
                value-format="yyyy-MM-dd"
                unlink-panels
                :clearable="false"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="changeTime($event)"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="item">
            <el-button size="mini" @click="searchYesterday">昨日</el-button>
          </div>
          <div class="item">
            <el-button size="mini" @click="searchToday">今日</el-button>
          </div>
          <div class="item">
            <el-button size="mini" type="primary" @click="handleSearch"
              >查询</el-button
            >
          </div>
        </div>
      </div>
      <user-list @refresh="refreshList"></user-list>
    </el-card>
    <!-- 添加用户信息弹框 -->
  </div>
</template>

<script>
import "./store";
import UserList from "./components/list";
import { mapState, mapActions, mapMutations } from "vuex";
import { QUERY_TYPE, PAGINATION } from "./constants";
import moment from "moment";
export default {
  name: "rebateReview",
  components: {
    UserList,
  },
  data() {
    return {
      value2: "",
      dialogVisible: false,
      userId: "",
      channelId: "",
      channelUserId: "",
      remark: "",
      inviteBy: "",
      value1: [
        moment(new Date().getTime() - 7 * 1000 * 24 * 60 * 60).format(
          "YYYY-MM-DD"
        ),
        new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1) +
          "-" +
          new Date().getDate(),
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  computed: {
    ...mapState("rebateReview", ["queryType", "pagination"]),
    ...mapState(["userInfo"]),
  },
  methods: {
    ...mapActions("rebateReview", ["list", "addUser"]),
    ...mapMutations("rebateReview", ["setQueryType"]),
    refreshList(data = {}) {
      this.list({
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        channelUserId: this.channelUserId,
        remark: this.remark,
        ...this.pagination,
        ...data,
      });
    },
    changeTime(e) {
      this.list({
        startTime: e[0],
        endTime: e[1],
        channelUserId: this.channelUserId,
        remark: this.remark,
        ...PAGINATION,
      });
    },
    searchYesterday() {
      this.value1 = [
        moment(new Date().getTime() - 1 * 1000 * 24 * 60 * 60).format(
          "YYYY-MM-DD"
        ),
        moment(new Date().getTime() - 1 * 1000 * 24 * 60 * 60).format(
          "YYYY-MM-DD"
        ),
      ];
      this.handleSearch();
    },
    searchToday() {
      this.value1 = [
        new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1) +
          "-" +
          new Date().getDate(),
        new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1) +
          "-" +
          new Date().getDate(),
      ];
      this.handleSearch();
    },
    handleSearch() {
      this.list({
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        channelUserId: this.channelUserId,
        remark: this.remark,
        ...PAGINATION,
      });
    },
    handleSave() {},
    closeDialog() {
      this.dialogVisible = false;
    },
    onOpen() {},
    onClose() {
      this.$refs["elForm"].resetFields();
      this.dialogVisible = false;
    },
    close() {
      // this.$emit("update:visible", false);
      this.$refs["elForm"].resetFields();
      this.dialogVisible = false;
    },
  },
  created() {
    this.list({
      startTime: this.value1 ? this.value1[0] : "",
      endTime: this.value1 ? this.value1[1] : "",
      channelUserId: this.channelUserId,
      remark: this.remark,
      ...PAGINATION,
    });
  },
};
</script>

<style lang="less" src="../../styles/button.less" scoped></style>
